<template>
  <v-row dense>
    <v-col cols="3">
      <DatePicker
        v-model="date"
        default-value
        :filled="false"
        :disabled="loading"
        label="На дату(включно)"
        @input="changeFilter"
      />
    </v-col>
    <v-col>
      <ClientSelect
        v-model="client"
        label="Фільтр по клієнтам"
        :disabled="loading"
        :is-dense="true"
        placeholder="Введіть назву клієнта"
        @input="changeFilter"
      />
    </v-col>
    <v-col>
      <EmployeeSelect
        v-model="employee"
        :disabled="loading"
        label="Фільтр по виконавцям"
        placeholder="Введіть iм’я виконавця"
        :hide-details="false"
        @input="changeFilter"
      />
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from "@/components/story/DatePicker";
import ClientSelect from "../../../components/selects/ClientSelect.vue";
import EmployeeSelect from "../../catalogs/employees/EmployeeSelect.vue";

export default {
  components: {
    DatePicker,
    ClientSelect,
    EmployeeSelect,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    date: null,
    client: null,
    employee: null,
  }),
  methods: {
    changeFilter() {
      this.$emit("input", {
        client: this.client,
        employee: this.employee,
        date: this.date,
      });
    },
  },
};
</script>
